import React, { FCC } from 'react';
import { IRadioLabelProps } from './types';

/**
 * Support Bootstrap structure
 */
export const RadioLabel: FCC<IRadioLabelProps> = (props) => {
  if (props.inline) {
    return <label className={'radio-inline'}>{props.children}</label>;
  }
  return (
    <div className={'radio'}>
      <label>{props.children}</label>
    </div>
  );
};

export default RadioLabel;
